import { courses } from './constants.js';
import { parseLenex } from './lenex-parse.js';
export class Lenex {
    constructor(file) {
        this.accepted_lenex_versions = [3, "3.0"];
        this.file = file;
        this.raw = null;
        this.athleteMap = {};
        this.eventsMap = {};
        this.clubsMap = {};
        this.clubsMapCode = {};
    }
    async init() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.raw = await parseLenex(this.file);
        delete this.file;
        if (!this.accepted_lenex_versions.includes(this.raw.version)) {
            throw new Error(`Unsupported lenex version: ${this.raw.version} Supported versions: (${this.accepted_lenex_versions.join(", ")})`);
        }
        this.eventsMap = (_b = (_a = this.raw.meets) === null || _a === void 0 ? void 0 : _a.flatMap(meet => meet.sessions).flatMap(session => session.events).reduce((prev, cur) => (Object.assign(Object.assign({}, prev), { [cur.eventid]: cur })), {})) !== null && _b !== void 0 ? _b : {};
        this.athleteMap = (_d = (_c = this.raw.meets) === null || _c === void 0 ? void 0 : _c.flatMap(meet => meet.clubs).filter(notNull).flatMap(club => {
            var _a, _b;
            return (_b = (_a = club.athletes) === null || _a === void 0 ? void 0 : _a.map(athlete => (Object.assign(Object.assign({}, athlete), { club })))) !== null && _b !== void 0 ? _b : [];
        }).reduce((prev, cur) => (Object.assign(Object.assign({}, prev), { [cur.athleteid]: cur })), {})) !== null && _d !== void 0 ? _d : {};
        this.clubsMap = (_f = (_e = this.raw.meets) === null || _e === void 0 ? void 0 : _e.flatMap(meet => meet.clubs).filter(notNull).reduce((prev, cur) => (Object.assign(Object.assign({}, prev), { [cur.clubid]: cur })), {})) !== null && _f !== void 0 ? _f : {};
        this.clubsMapCode = (_h = (_g = this.raw.meets) === null || _g === void 0 ? void 0 : _g.flatMap(meet => meet.clubs).filter(notNull).reduce((prev, cur) => (Object.assign(Object.assign({}, prev), { [cur.code]: cur })), {})) !== null && _h !== void 0 ? _h : {};
    }
    get rawLenexData() {
        return JSON.parse(JSON.stringify(this.raw));
    }
    getEventById(id) {
        return this.eventsMap[id];
    }
    getAthleteById(id) {
        return this.athleteMap[id];
    }
    getClubById(id) {
        return this.clubsMap[id];
    }
    getClubByClubCode(clubCode) {
        return this.clubsMapCode[clubCode];
    }
    get constructorInfo() {
        return this.raw.constructor;
    }
    get meetCourse() {
        const c = this.raw.meets[0].course;
        return Object.assign({ type: c }, courses[c]);
    }
}
function notNull(a) {
    return a != null;
}
